@for (pf of recursiveList; track pf; let parentIndex = $index) {
  <div>
    @for (pfs of pf.Settings; track pfs) {
      <div>
        @if (pfs.Type == 'boolean') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <input type="checkbox" [checked]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)" style="vertical-align:middle;"/>
            </span>
          </a>
        }
        @if (pfs.Type == 'string') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <input type="text" class="input" [value]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)" style="vertical-align:middle;"/>
            </span>
          </a>
        }
        @if (pfs.Type == 'multiline') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <textarea class="textarea" [value]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)"></textarea>
            </span>
          </a>
        }
        @if (pfs.Type == 'media') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <app-mediaupload [MediaId]="pfs.Value" [IsPublic]="true" (MediaIdChange)="UpdateSettingItemValue(pfs, $event)"></app-mediaupload>
            </span>
          </a>
        }
        @if (pfs.Type == 'int') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <input type="number" [value]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)" class="input" style="vertical-align:middle;"/>
            </span>
          </a>
        }
        @if (pfs.Type == 'currency') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <app-currency-input [InternalValue]="pfs.Value" (ValueChanged)="UpdateSettingItemValue(pfs, $event)"></app-currency-input>
            </span>
          </a>
        }
        @if (pfs.Type == 'intOptions') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <div class="select">
                <select class="input"  [(ngModel)]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)">
                  @for (permissionlevel of pfs.PermissionLevels; track permissionlevel) {
                    <option [value]="permissionlevel.Level">{{permissionlevel.Permission}}</option>
                  }
                </select>
              </div>
            </span>
          </a>
        }
        @if (pfs.Type == 'stringOptions') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <div class="select">
                <select class="input" [(ngModel)]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)">
                  @for (permissionlevel of pfs.PermissionLevels; track permissionlevel) {
                    <option [value]="permissionlevel.Description">{{permissionlevel.Permission}}</option>
                  }
                </select>
              </div>
            </span>
          </a>
        }
        @if (pfs.Type == 'datetime-local') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <input type="datetime-local" [value]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)" class="input" style="vertical-align:middle;"/>
            </span>
          </a>
        }
        @if (pfs.Type == 'api') {
          <a class="panel-block">
            <span class="label">{{pfs.DisplayName}}</span>
            <span class="value">
              <div class="select">
                <select class="input" [(ngModel)]="pfs.Value" (change)="UpdateSettingItemValue(pfs, $event)">
                  @for (value of pfs.SelectItems; track value) {
                    <option [value]="value.Id">{{value.Name}}</option>
                  }
                </select>
              </div>
            </span>
          </a>
        }
      </div>
    }
    <app-treenodepanelblock [recursiveList]="pf.Children" (updateSettingValue)="UpdateSettingItem($event)"></app-treenodepanelblock>
  </div>
}

